import React, { useState } from 'react'
import { MySwal } from '../../../lib/swal'
import axios from '../../../lib/axios'
import errorHandler from '../../../helpers/errorHandler';

const FormEditPicCorporate = (props) => {
    // console.log(props.user)
    const [disabled, setDisabled] = useState(false);
    const [required, setRequired] = useState(false);
    const [NamaDepan, setNamaDepan] = useState(props.user.firstName);
    const [NamaBelakang, setNamaBelakang] = useState(props.user.lastName);
    const [HpPic, setHpPic] = useState(props.user.mobilePhone);
    const [EmailPic, setEmailPic] = useState(props.user.email);

    const handleUpdate = async () => {
        try {
            setDisabled(true)
            if (
                EmailPic.length === 0 &&
                NamaBelakang.length === 0 &&
                HpPic.length === 0
            ) {
                setRequired(true)
                MySwal.fire({
                    position: 'top-end',
                    icon: 'warning',
                    title: '<h2>Oops, Gagal</h2>',
                    html: '<h5>Beberapa input tidak boleh kosong!</h5>',
                    showConfirmButton: false,
                    timer: 3000
                })
                setDisabled(false)
            } else {
                const formData = new FormData()
                formData.append('firstNamePic', NamaDepan)
                formData.append('lastNamePic', NamaBelakang)
                formData.append('emailPic', EmailPic)
                formData.append('mobilePhonePic', HpPic)
                formData.append('companyNamePic', props.user.Account.name)
                formData.append('identityTypePic', props.user.identityType !== null ? props.user.identityType : 'NIK')
                formData.append('identityNumberPic', props.user.identityNumber)
                formData.append('jobPic', props.user.job)
                formData.append('jobPositionPic', props.user.jobPosition)
                formData.append('companyName', props.user.Account.name)
                formData.append('companyType', props.user.Account.type)
                formData.append('companyIndustryClassification', props.user.Account.industryClassification)
                formData.append('companyNpwpNumber', props.user.Account.npwp)
                formData.append('companyEmail', props.user.Account.email)
                formData.append('companyPhone', props.user.Account.phone)
                formData.append('companyMobilePhone', props.user.Account.mobilePhone)
                formData.append('companyBillingCountry', props.user.Account.billingCountry)
                formData.append('companyBillingState', props.user.Account.billingState)
                formData.append('companyBillingCity', props.user.Account.billingCity)
                formData.append('companyBillingSubdistrict', props.user.Account.billingSubdistrict)
                formData.append('companyBillingStreet', props.user.Account.billingStreet)
                formData.append('companyBillingZip', props.user.Account.billingZip)
                formData.append('companyShippingCountry', props.user.Account.shippingCountry)
                formData.append('companyShippingState', props.user.Account.shippingState)
                formData.append('companyShippingCity', props.user.Account.shippingCity)
                formData.append('companyShippingSubdistrict', props.user.Account.shippingSubdistrict)
                formData.append('companyShippingStreet', props.user.Account.shippingStreet)
                formData.append('companyShippingZip', props.user.Account.shippingZip)

                // Display the key/value pairs
                // for (var pair of formData.entries()) {
                //     console.log(pair[0] + ', ' + pair[1]);
                // }
                // return false

                const { data } = await axios({
                    url: `/users/users`,
                    method: 'PUT',
                    data: formData,
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
                })

                // console.log(data)

                if (data.code === "200") {
                    setRequired(false)
                    MySwal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: '<h2>Sukses</h2>',
                        html: '<h5>Berhasil menyimpan data!</h5>',
                        showConfirmButton: false,
                        timer: 3000
                    })
                    setTimeout(() => {
                        props.close()
                        setDisabled(false)
                    }, 3000);
                }
            }
        } catch (err) {
            setRequired(true)
            errorHandler({ err: err?.response?.data || err })
            setDisabled(false)
            console.log(err)
        }
    }

    return (
        <>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="namaDepan" className="col-form-label">Nama Depan</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setNamaDepan(e.target.value)} style={{ fontSize: '14px', color: '#191919', fontWeight: '500' }} type="text" className="form-control" id="namaDepan" value={NamaDepan} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (NamaBelakang.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="namaBelakang" className="form-label required">Nama Belakang</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setNamaBelakang(e.target.value)} style={{ fontSize: '14px', borderColor: (NamaBelakang.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control" id="namaBelakang" value={NamaBelakang} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (HpPic.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="hpPic" className="form-label required">No Telepon/HP PIC</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setHpPic(e.target.value)} style={{ fontSize: '14px', borderColor: (HpPic.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control" id="hpPic" value={HpPic} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="emailPic" className="form-label required">Email</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setEmailPic(e.target.value)} style={{ fontSize: '14px', color: '#191919', fontWeight: '500' }} type="text" className="form-control" id="emailPic" value={EmailPic} />
                </div>
            </div>
            <hr></hr>
            <div className="mb-3 row d-flex" style={{ textAlign: 'right' }}>
                <div>
                    <button onClick={() => props.close()} className="btn btn-bg-white" style={{ marginRight: '10px' }}>Batal</button>
                    <button onClick={handleUpdate} className="btn btn-success" disabled={disabled}>
                        {
                            disabled === true ?
                                'Mohon tunggu...'
                                :
                                'Simpan Perubahan'
                        }
                    </button>
                </div>

            </div>
        </>
    )
}

export default FormEditPicCorporate
